import { warn } from '@execonline-inc/logging';
import { putQueryParam, toUrlT } from '@execonline-inc/url';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { callApi } from '../../../Appy';
import { SearchParameters } from '../../../ListFilter/Types';
import ReactionComponent, { RCProps } from '../../../ReactionComponent';
import { Link } from '../../../Resource/Types';
import { productLicensesOverviewResourceDecoder } from './Decoders';
import { ProductLicensesStore } from './Store';
import { LoadError, State } from './Types';

const getProductLicenses = callApi(productLicensesOverviewResourceDecoder, {});

const assignSearchParameters = (searchParameters: SearchParameters) => (link: Link) => {
  return toUrlT(link.href)
    .map((url) =>
      searchParameters.reduce(
        (acc, parameter) =>
          putQueryParam(
            `product_licenses_overviews_filter[${parameter.key}]`,
            parameter.value,
          )(acc),
        url,
      ),
    )
    .map((urlParser) => ({ ...link, href: urlParser.href }));
};

export class ProductLicensesReactions extends ReactionComponent<
  ProductLicensesStore,
  State,
  RCProps<ProductLicensesStore>
> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    switch (state.kind) {
      case 'waiting':
        break;
      case 'loading':
        Task.succeed<LoadError, Link>(state.link)
          .andThen(assignSearchParameters(state.searchParameters))
          .andThen(getProductLicenses)
          .fork(this.props.store.loadingError, this.props.store.ready);
        break;
      case 'loading-error':
        warn('Could not load product licenses', JSON.stringify(state.error));
        break;
      case 'ready':
        break;
      default:
        assertNever(state);
    }
  };
}
